/*
 * @Author: fuyu
 * @Date: 2020-06-23 14:53:37
 * @LastEditors: fuyu
 * @LastEditTime: 2021-08-21 13:48:05
 * @FilePath: /jest-vue/src/permission.js
 */
import router from "./router";
import Storage from "@/tools/storage";
import getQueryString from "@/tools/getUrlParams";
//progress
import Progress from "nprogress";
import "nprogress/nprogress.css";
import { wechatLogin } from "@/api/user";
import store from "./store";
const checkToken = (next, to) => {
  let src = window.location.href;
  const token = Storage.get("token");
  let url;
  if (token || Storage.get("license") || Storage.get("shareLicense")) {
    url = window.location.href;
    return next();
  }
  if (src.indexOf("openid=") != -1) {
    let string = src.indexOf("openid=");
    let names = src.substring(string);
    let num = names.indexOf("=");
    let name = names.substring(num + 1);
    Storage.set("openid", name);
  }
  // 演示链接 添加转发测试
  if(to.path == "/reportInfo/forwarding" && getQueryString("id") == 'cnb518tkh0ou8lx9'){
    Storage.set("openid", 'oEhm60nYZhe5Oe9m5NSnBBKMrQ7w');
  }
  // short = 1 区别是否为分享页面
  if ( 
    (src.indexOf("short=1") != -1 || to.query.smslink == 1 || to.query.pushLinkType == 1 ) &&
    (to.path == "/reportInfo/report" || to.path == "/reportInfo/reportStemp" || to.path == "/reportInfoWangShuai/report")
  ) {
    if (to.fullPath.indexOf("?") != -1) {
      Storage.set("reportParams", to.fullPath.split('?')[1]);
      next()
      return
    }
  } else if (
    src.indexOf("short=1") != -1 &&
    to.path == "/reportInfo/portrait"
  ) {
    Storage.set("reportPermissions", 2);
    return next({
      path: "/reportInfo/portrait",
    });
  } else if (
    to.path == "/reportInfo/attachment"
  ) {
    next();
    return;
  }else if (
    to.path == "/reportInfo/image"
  ) {
    next();
    return;
  }else {
    if (to.path == "/remoteList") {
      Storage.set("remoteUrl", 1);
    }
    wechatLogin({
      openid: Storage.get("openid"),
      // openid: 'oEhm60nYZhe5Oe9m5NSnBBKMrQ7w'
    }).then((res) => {
      if (res) {
        // Storage.set('openid', 'oEhm60nYZhe5Oe9m5NSnBBKMrQ7w')
        store.dispatch("setToken", res.token);
        //判断是否为推送
        if (
          src.indexOf("report_id=") != -1 &&
          src.indexOf("/reportInfo/report") != -1
        ) {
          if (res.phone) Storage.set("phone", res.phone);
          return next({
            path: url,
          });
        }
        if (res.phone) {
          Storage.set("phone", res.phone);
          if (to.path == "/reportList") {
            return next({
              path: "/reportList",
            });
          } else if (to.path == "/remoteList") {
            Storage.set("remoteUrl", 1);
            return next({
              path: "/remoteList",
            });
          } else if (to.path == "/checkInfo") {
            return next({
              path: "/checkInfo",
            });
          }else if(to.path == "/reportInfo/forwarding" && getQueryString("id") == 'cnb518tkh0ou8lx9'){
            return next()
          }else {
            return next({
              path: "/filmQuery",
            });
          }
        } else {
          return next({
            path: "/",
            replace: true
          });
        }
      }
      Progress.done();
      return next({
        path: "/404",
      });
    });
  }
};
router.beforeEach((to, from, next) => {
  Progress.start();
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.path == "/reportInfo/portrait") {
    next();
    return;
  }else if (to.path == "/verifyPhone") {
    next();
    return;
  } else if (to.path == "/reportListOuter" || to.path == "/reportListQuery") {
    let institution_id = getQueryString("institution_id");
    let type = getQueryString("type"); // 1 按照病例号搜索 2 检查号 3 门诊住院号
    let token = getQueryString("token");
    let code = getQueryString("code");
    const isForwardedReportList =
      to.path == "/reportListOuter" && !institution_id && type && code;
    if (isForwardedReportList) {
      // A direct forwarding link must not reuse search/report data left by a
      // previous visit. Clear both stores before the page component is created.
      window.localStorage.clear();
      Storage.cle();
    } else if (institution_id && type) {
      // let code = getQueryString("code").replace(" ", "+");
      code = unescape(code)
      if(code == 'null') {
        code = getQueryString("CheckID")
        if(code) {
          code = window.atob(code)
        }
      }
      let outerLinkParams = {
        institution_id: institution_id,
        type: type,
        code: code,
        token: token ? token : undefined,
      };
      Storage.set("outerLinkParams", outerLinkParams);
    } else {
      Storage.del("outerLinkParams");
    }
    next();
    return;
  }else if (to.path == "/checkInfoOuter/search") {
    // 承德双滦区人民医院
    // Start a new search with no stale report or institution data.
    window.localStorage.clear();
    Storage.cle();
    next();
    return;
  } else if (to.path == "/reportInfoOuter") {
    next();
    return;
  }else if (to.path == "/reportInfoShare") {
    next();
    return;
  }else if (to.path == "/reportInfoQuery") {
    next();
    return;
  } else if (to.path == "/reportInfoOuter_GZ") {
    next();
    return;
  } else if (to.path == "/reportInfoOuter_JX") {
    next();
    return;
  }else if (to.path == "/reportListOuter_JX") {
    next();
    return;
  } else if (to.path == "/printOuter") {
    next();
    return;
  } else if (to.path == "/printOuter1") {
    next();
    return;
  } else if (to.path == "/checkInfoOuter/27400005") {
    next();
    return;
  } else if (to.path == "/checkInfoOuter/25500004") {
    next();
    return;
  } else if (to.path == "/checkInfoOuter/41000009") {
    //长沙乐好妇产医院
    next();
    return;
  } else if (to.path == "/checkInfoOuter/52200003") {
    //揭西县人民医院
    next();
    return;
  } else if (to.path == "/checkInfoOuter/43800001") {
    //武穴市第一人民医院
    next();
    return;
  } else if (to.path == "/checkInfoOuter/46700002") {
    //平顶山市第二人民医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/43600001") {
    //鄂州市中心医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/75000001") {
    //银川市口腔医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/71900005") {
    //绥德县医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/71900006") {
    //米脂县医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/71900007") {
    //榆林市第一医院榆林院区
    next();
    return;
  }else if (to.path == "/checkInfoOuter/71900008") {
    //榆林市第一医院绥德院区
    next();
    return;
  }else if (to.path == "/checkInfoOuter/27400007") {
    //单县正大康复医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/27100005") {
    //山东颐养健康集团肥城医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/27100006") {
    //泰安市岱岳区妇幼保健院 
    next();
    return;
  } else if (to.path == "/checkInfoOuter/25500005") {
    // 山东颐养健康集团莱芜中心医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/06700001") {
    // 承德市中医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/74400013") {
    // 崇信县中医医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/71900001") {
    // 榆林市第四（星元）医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/27100009") {
    // 东平县疾病预防控制中心
    next();
    return;
  }else if (to.path == "/checkInfoOuter/73000005") {
    // 榆中县第一人民医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/30000004") {
    // 天津大学新城医院
    next();
    return;
  }else if (to.path == "/checkInfoOuter/72700001") {
    // 铜川矿务局中心医院
    next();
    return;
  }else if (to.path == "/healthImageDetail") {
    next();
    return;
  }
  else if (to.path == "/jump") {
    next();
    return;
  }
  if (to.path == "/404") {
    next();
    return;
  }
  return checkToken(next, to);
});

router.afterEach(() => {
  Progress.done(); // 结束Progress
});
